module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item11-b5edf33a82d9192018d60bba8a3ffb56.svg";